import React, { useRef, useState } from 'react';
import ActionMenu from 'src/components/layouts/ActionMenu/ActionMenu';
import styles from './TrackingTopBar.module.scss';
import Button, { ButtonProps } from '../Button/Button';
import Image from '../Image/Image';
import { OptionItemProps } from '../OptionItem/OptionItem';
import Icon from '../Icon/Icon';

export interface TrackingTopBarProps {
  imgSrc: string;
  buttons?: ButtonProps[];
  menuItems?: OptionItemProps[];
}

const TrackingTopBar: React.FC<TrackingTopBarProps> = ({ imgSrc, buttons = [], menuItems = [] }) => {
  const [menuVisible, setMenuVisible] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const toggleMenu = (event: React.MouseEvent | React.KeyboardEvent) => {
    event.stopPropagation();
    setMenuVisible(prevVisible => !prevVisible);
  };

  return (
    <div className={styles.root}>
      <div className={styles.image}>
        <Image imageUrl={imgSrc} alt="logo" fallbackComponent={<div>Loading...</div>} />
      </div>
      <div className={styles.buttons}>
        {buttons.length > 0 && buttons.map(b => <Button key={Math.random()} {...b} />)}
      </div>
      <div className={styles.menu}>
        {menuItems.length > 0 && (
          <button type="button" ref={buttonRef} onClick={toggleMenu} aria-label="Settings">
            <Icon name="settings" className={`${menuVisible ? 'settingsOpen' : 'text-faded'} cursor-pointer`} />
          </button>
        )}
        {menuVisible && (
          <div className={styles.actionMenu} ref={menuRef}>
            <ActionMenu items={menuItems} />
          </div>
        )}
      </div>
    </div>
  );
};

export default TrackingTopBar;
